import React, { useEffect } from 'react';
import { Dialog, Slide } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NewDialog({ open, label, onClose, children, maxWidth = 'xs' }) {
  const handlePopState = () => {
    if (open) {
      onClose();
      window.history.back();
    }
  };
  useEffect(() => {
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [open]);

  return (
    <Dialog
      fullWidth
      dir="rtl"
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      TransitionComponent={Transition}
      aria-labelledby={`${label}-dialog-title`}
      aria-describedby={`${label}-dialog-description`}
      PaperProps={{
        sx: {
          p: 0,
          m: 0.5,
          width: '100%',
          alignSelf: { xs: 'flex-end', md: 'center' },
        },
      }}
    >
      {children}
    </Dialog>
  );
}
